import React from 'react';
import classNames from 'classnames';
import useSheet from 'app/jss';
import themeConfig from 'app/theme';
import { linearGradient } from '../../utils/cssUtils';

type Props = {
  direction: 'topleft' | 'topright',
  kind: 'primary' | 'warning',
  icon: string,
  sheet: Object,
};

const defaultProps = {
  direction: 'topleft',
  kind: 'primary',
  theme: 'default',
};

function CornerMark({
  direction,
  icon,
  kind,
  sheet: { classes },
}: Props) {
  const gradientAngle = direction === 'topleft' ? 135 : -135;
  const color = themeConfig.color[kind];
  const style = {
    backgroundImage: linearGradient(`${gradientAngle}deg`, `${color} 50%`, 'transparent 50%'),
  };

  return (
    <span style={style} className={classNames(classes.markWrapper, direction)}>
      <span className={classNames(`ion-${icon}`, classes.mark)} />
    </span>
  );
}

CornerMark.defaultProps = defaultProps;

function applyStyles() {
  return {
    markWrapper: {
      color: 'white',
      display: 'flex',
      lineHeight: 1,
      width: '1.8em',
      height: '1.8em',
      paddingTop: 1,
      paddingLeft: 1,
      fontSize: '0.8em',
      // Hack: Anti-alises the gradient, make it not jaggy
      transform: 'rotate(360deg)',
      '&.topleft': {
      },
      '&.topright': {
        justifyContent: 'flex-end',
        marginLeft: 'auto',
      },
    },
    mark: {
      // give the icon a height/width, this ensures all icons
      // are the same size
      height: '1em',
      width: '1em',
    },
  };
}

export default useSheet(applyStyles)(CornerMark);
